import { controller, rolesObj } from '../controller'
import { localStorageService } from '../../helpers'
export const pageCompareEventApprovalController = () => {
  const roles = localStorageService.getUserData()
  const obj = controller().checkRole(roles)
  return {
    asset: () => {
      const { roleSingle, roles } = obj
      if (roles) {
        const systemadmin = controller().filterRole(
          roles,
          res => res.id === rolesObj.systemadmin
        )
        const admin = controller().filterRole(
          roles,
          res => res.id === rolesObj.admin
        )
        const user = controller().filterRole(
          roles,
          res => res.id === rolesObj.user
        )
        const risk = controller().filterRole(
          roles,
          res => res.id === rolesObj.risk
        )
        const purchaser = controller().filterRole(
          roles,
          res => res.id === rolesObj.purchaser
        )
        const tec = controller().filterRole(
          roles,
          res => res.id === rolesObj.tec
        )
        const approver = controller().filterRole(
          roles,
          res => res.id === rolesObj.approver
        )
        const observer = controller().filterRole(
          roles,
          res => res.id === rolesObj.observer
        )
        if (roleSingle) {
          if (systemadmin.length !== 0) {
            return {
              check: false,
              roles: 'systemadmin',
            }
          } else if (admin.length !== 0) {
            return {
              check: false,
              roles: 'admin',
            }
          } else if (user.length !== 0) {
            return {
              check: false,
              roles: 'user',
            }
          } else if (risk.length !== 0) {
            return {
              check: false,
              roles: 'risk',
            }
          } else if (purchaser.length !== 0) {
            return {
              check: true,
              roles: 'purchaser',
            }
          } else if (tec.length !== 0) {
            return {
              check: false,
              roles: 'tec',
            }
          } else if (approver.length !== 0) {
            return {
              check: true,
              roles: 'approver',
            }
          } else if (observer.length !== 0) {
            return {
              check: false,
              roles: 'observer',
            }
          }
        } else {
          if (purchaser.length !== 0 || approver.length !== 0) {
            return {
              check: true,
              roles: purchaser.length !== 0 ? 'purchaser' : 'approver',
            }
          } else {
            return {
              check: false,
              roles: '',
            }
          }
        }
      } else {
        return {
          check: false,
          roles: '',
        }
      }
    },
    assetCancelReq: () => {
      const { roleSingle, roles } = obj
      if (roles) {
        const systemadmin = controller().filterRole(
          roles,
          res => res.id === rolesObj.systemadmin
        )
        const admin = controller().filterRole(
          roles,
          res => res.id === rolesObj.admin
        )
        const user = controller().filterRole(
          roles,
          res => res.id === rolesObj.user
        )
        const risk = controller().filterRole(
          roles,
          res => res.id === rolesObj.risk
        )
        const purchaser = controller().filterRole(
          roles,
          res => res.id === rolesObj.purchaser
        )
        const tec = controller().filterRole(
          roles,
          res => res.id === rolesObj.tec
        )
        const approver = controller().filterRole(
          roles,
          res => res.id === rolesObj.approver
        )
        const observer = controller().filterRole(
          roles,
          res => res.id === rolesObj.observer
        )
        if (roleSingle) {
          if (systemadmin.length !== 0) {
            return {
              check: true,
              roles: '',
            }
          } else if (admin.length !== 0) {
            return {
              check: true,
              roles: '',
            }
          } else if (user.length !== 0) {
            return {
              check: false,
              roles: '',
            }
          } else if (risk.length !== 0) {
            return {
              check: false,
              roles: '',
            }
          } else if (purchaser.length !== 0) {
            return {
              check: true,
              roles: '',
            }
          } else if (tec.length !== 0) {
            return {
              check: false,
              roles: '',
            }
          } else if (approver.length !== 0) {
            return {
              check: false,
              roles: '',
            }
          } else if (observer.length !== 0) {
            return {
              check: false,
              roles: '',
            }
          }
        } else {
          if (
            purchaser.length !== 0 ||
            systemadmin.length !== 0 ||
            admin.length !== 0
          ) {
            return {
              check: true,
              roles: '',
            }
          } else {
            return {
              check: false,
              roles: '',
            }
          }
        }
      } else {
        return {
          check: false,
          roles: '',
        }
      }
    },
  }
}
